import { SCREEN_NAMES } from '@/lib/analytics/consts.js'
import { useAnalytics } from '@/composables/analytics/index.js'
import { useRouter } from 'vue-router'
import { ref } from 'vue'

const lastStateScreenName = ref(null)
const propertiesContext = ref({})

const routeStrategies = {
  'settings.loyalty-program': (currentScreenName) => {
    return currentScreenName !== SCREEN_NAMES.LP_MAIN_SCREEN
      ? SCREEN_NAMES.LP_ACTIVATION
      : currentScreenName
  },
  'settings.loyalty-program.program': (currentScreenName) => currentScreenName,
  'settings.loyalty-program.cards.list': (currentScreenName) => {
    return currentScreenName !== SCREEN_NAMES.LC_CARDS
      ? SCREEN_NAMES.LC_MANAGE
      : currentScreenName
  },
  default: () => null,
}

const getRouteStrategy = (routeName) => {
  return routeStrategies[routeName] || routeStrategies.default
}

// Screen-specific property mappings
const screenProperties = {
  [SCREEN_NAMES.LP_MAIN_SCREEN]: () => ({
    loyaltyCardsActivated: propertiesContext.value.loyaltyCardsActivated,
    clickSource: propertiesContext.value.clickSource,
  }),

  [SCREEN_NAMES.LP_SETTINGS]: () => ({
    loyaltyCardsActivated: propertiesContext.value.loyaltyCardsActivated,
    loyaltyProgramId: propertiesContext.value.loyaltyProgramId,
  }),
}

const getProperties = () => {
  return screenProperties[lastStateScreenName.value]?.() || {}
}

const updatePropertiesContext = (context) => {
  propertiesContext.value = { ...propertiesContext.value, ...context }
}

// Reset function for testing
const resetLoyaltyAnalyticsState = () => {
  lastStateScreenName.value = null
  propertiesContext.value = {}
}

export const useLoyaltyAnalytics = () => {
  const analytics = useAnalytics()
  const router = useRouter()

  const sendEvent = ({ eventAction, screenName }) => {
    if (screenName) {
      lastStateScreenName.value = screenName
    } else {
      const currentRoute = router.currentRoute.value.name
      const strategy = getRouteStrategy(currentRoute)
      lastStateScreenName.value = strategy(lastStateScreenName.value)
    }

    if (lastStateScreenName.value) {
      analytics.dispatch(analytics.EVENTS.LOYALTY_CARD_ACTION, {
        screenName: lastStateScreenName.value,
        eventAction,
        ...getProperties(),
      })
    }
  }

  return {
    sendEvent,
    updatePropertiesContext,
    resetLoyaltyAnalyticsState,
  }
}
